import {useTheme} from "@mui/material/styles";
import React from "react";
import {Box, Button, Step, StepLabel, Stepper} from "@mui/material";

export function DeckCreationStepperView({stepNames, currentStep, onStepBack}) {

    const theme = useTheme();


    return (
        <Box sx={{ width: '100%', display: "flex", alignItems: 'center' }}>
            <Button
                color="inherit"
                disabled={currentStep === 0}
                onClick={onStepBack}
                sx={{ mr: 1 }}
            >
                Back
            </Button>
            <Stepper activeStep={currentStep} sx={{width: '100%', color: theme.palette.warning.main + "!important"}}>
                {stepNames.map((stepName, stepIndex) => (
                    <Step
                        key={stepIndex}
                        completed={stepIndex < currentStep}
                        sx={{
                            '& .MuiStepLabel-root .Mui-active': {
                                color: 'purple.main', // circle color (COMPLETED)
                            },
                            '& .MuiStepLabel-root .Mui-completed': {
                                color: 'purple.main', // circle color (COMPLETED)
                            },
                        }}>
                        <StepLabel >{stepName}</StepLabel>
                    </Step>
                ))}
            </Stepper>
        </Box>
    );

}